const menu = {
  label: '• Setor Econômico',
  to: '/sol/setoreconomico',
  rules: ['SOL-001'],
}

export default menu;